export enum FeatureToggle {
  ASTHMA = "asthma",
  LIVER_TRANSPLANT = "liver-transplant",
  AVANCE_NERVE_GRAFT = "avance-nerve-graft",

  DISABLE_LETTER_ISSUE_EMAILS = "disable-letter-issue-emails",

  EMAIL_INSURER = "email-insurer",

  MY_APPEALS_MODULAR_DESIGN = "my-appeals-modular-design",

  CLAUDE_OPUS_LETTER_GENERATION = "claude-opus-letter-generation",
  SINGLE_STEP_LETTER_GEN_GPT_5_4 = "single-step-letter-gen-gpt-5-4",

  QR_CODE_UPLOAD = "qr-code-upload",

  SHOW_GOOGLE_REVIEWS_WIDGET = "show-google-reviews-widget",

  LETTER_OF_MEDICAL_NECESSITY_GENERATION = "lomn-generation",
}
